import React from 'react'

type SVGProps = React.SVGProps<SVGSVGElement>

export function TwQuestionMark(props: SVGProps) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9993 29.3327C23.3631 29.3327 29.3327 23.3631 29.3327 15.9993C29.3327 8.63555 23.3631 2.66602 15.9993 2.66602C8.63555 2.66602 2.66602 8.63555 2.66602 15.9993C2.66602 23.3631 8.63555 29.3327 15.9993 29.3327Z"
        className="fill-moss-200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.345 10.6992C15.7243 10.5927 15.0859 10.7094 14.543 11.0285C14.0001 11.3476 13.5876 11.8485 13.3786 12.4426C13.1342 13.1372 12.373 13.5023 11.6783 13.2579C10.9837 13.0135 10.6187 12.2523 10.863 11.5577C11.281 10.3695 12.106 9.36762 13.1918 8.72945C14.2777 8.09127 15.5544 7.85799 16.7958 8.07092C18.0372 8.28385 19.1631 8.92925 19.9743 9.89281C20.7852 10.8562 21.2292 12.0754 21.2275 13.3347C21.227 14.7616 20.4766 15.8522 19.7009 16.5953C18.925 17.3388 18.0049 17.8546 17.3553 18.1658C17.3034 18.1907 17.2657 18.2262 17.2448 18.2569C17.2351 18.2712 17.2308 18.2818 17.229 18.2873C17.2274 18.2922 17.2275 18.2944 17.2275 18.2944V18.6668C17.2275 19.4032 16.6305 20.0001 15.8941 20.0001C15.1578 20.0001 14.5608 19.4032 14.5608 18.6668V18.2945C14.5608 17.1347 15.2922 16.1973 16.2032 15.7609C16.7318 15.5077 17.3692 15.1363 17.8561 14.6698C18.3431 14.2032 18.5608 13.7615 18.5608 13.3334L18.5608 13.3315C18.5617 12.7017 18.3398 12.0919 17.9342 11.6101C17.5286 11.1284 16.9657 10.8057 16.345 10.6992Z"
        className="fill-moss-500"
      />
      <path
        d="M17.3341 22.6668C17.3341 23.4032 16.7372 24.0001 16.0008 24.0001C15.2644 24.0001 14.6675 23.4032 14.6675 22.6668C14.6675 21.9304 15.2644 21.3334 16.0008 21.3334C16.7372 21.3334 17.3341 21.9304 17.3341 22.6668Z"
        className="fill-moss-500"
      />
    </svg>
  )
}
